import { ApplicationView, useController } from '@aha-app/mvc';
import classNames from 'classnames';
import React from 'react';
import { pluralize } from '@aha-app/aha-shared';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import {
  durations,
  DurationUnit,
  shortFormattedTime,
} from '../../../utils/time';
import VotingSessionController from './controllers/VotingSessionController';
import styles from './VotingSession.module.css';

export const VotingSetupTimerControls = ApplicationView(() => {
  const controller = useController(VotingSessionController);
  const { durationInSeconds, timeLimited } = controller.state;
  const { unit: durationUnit, string: durationString } =
    shortFormattedTime(durationInSeconds);
  const { factor, shortName } = durations[durationUnit];

  const noTimeLimitText = 'No time limit';
  let timeLimitText = noTimeLimitText;
  if (timeLimited) {
    timeLimitText =
      durationUnit === DurationUnit.Days
        ? pluralize(Math.floor(durationInSeconds / factor), shortName)
        : shortName;
  }

  const durationChangeValue = factor; // plus / minus buttons change duration by 1 unit
  const canDecrementDuration = durationInSeconds - durationChangeValue > 0;

  return (
    <li className='flex-row flex-row--align-center flex-row--justify-space-between'>
      <div className='flex-row flex-row--align-center gap-2'>
        {timeLimited && (
          <span className='h-300'>
            <strong>{durationString}</strong>
          </span>
        )}
        <aha-menu>
          <span
            slot='control'
            className={classNames('t-100', styles.menuTrigger)}
          >
            {timeLimitText}
            <aha-icon class='ml-2' icon='fa-solid fa-chevron-down' />
          </span>
          <aha-menu-content>
            <aha-menu-group>
              {[
                DurationUnit.Minutes,
                DurationUnit.Hours,
                DurationUnit.Days,
              ].map(unit => (
                <aha-menu-item
                  key={unit}
                  selected={customElementBoolAttr(
                    timeLimited && durationUnit === unit
                  )}
                  onClick={() => controller.actionSetDurationUnit(unit)}
                >
                  {unit}
                </aha-menu-item>
              ))}
            </aha-menu-group>
            <aha-menu-group>
              <aha-menu-item
                selected={customElementBoolAttr(!timeLimited)}
                onClick={() => controller.actionSetDurationUnit(null)}
              >
                {noTimeLimitText}
              </aha-menu-item>
            </aha-menu-group>
          </aha-menu-content>
        </aha-menu>
      </div>
      <div className='flex-row gap-2 py-1'>
        <aha-button
          kind='gray'
          class={styles.votingSquareButton}
          disabled={customElementBoolAttr(
            !timeLimited || !canDecrementDuration
          )}
          onClick={() =>
            controller.actionSetDuration(
              durationInSeconds - durationChangeValue
            )
          }
        >
          <i className='fa-solid fa-minus' />
        </aha-button>
        <aha-button
          kind='gray'
          class={styles.votingSquareButton}
          disabled={customElementBoolAttr(!timeLimited)}
          onClick={() =>
            controller.actionSetDuration(
              durationInSeconds + durationChangeValue
            )
          }
        >
          <i className='fa-solid fa-plus' />
        </aha-button>
      </div>
    </li>
  );
});
